<div id="civil-disclaimer-div" class="text-center" tabindex="50" appFocusable>
  <button type="button" class="close" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true">×</span>
  </button>
  <div *ngIf="userStep === 'initial'">
      <h3>Before you proceed:</h3>
      
        <p>We would like your input on our modernized approach to providing public access to non-criminal court records. During this testing phase, data will not be synchronized from the clerk’s record in real time.</p>
        <p class="search-record-last-updated-info">The information was last updated from the system of record on  {{searchRecordLastUpdateDate|date:'MM/dd/yyyy'}} at {{searchRecordLastUpdateDate|date:'shortTime'}}.</p>
      
        <button id="civil-disclaimer-vcap" class="btn btn-primary btn-block disclaimer-btn" (click)="goToVcapInstructions()" tabindex="51">I need the most current data. Show me how using VCAP.</button>
        <button id="civil-disclaimer-proceed" class="btn btn-primary btn-block disclaimer-btn" (click)="yes()" tabindex="52">I’d like to try the modern application even if some information may be out of date.</button>
      </div>
  <div *ngIf="userStep === 'vcap'">
      <p>Switch from this application to the VCAP application to view 100% current non-criminal public records by pressing </p>
      <img src="./assets/images/alttab.png">
      <p>Press the combination again to return here.</p>
      
      <p>Or...</p>
      <button id="civil-disclaimer-proceed-from-vcap" class="btn btn-primary btn-block" (click)="yes()" tabindex="53">… let me try the modern version, even if some information may be out of date.</button>
    </div>
</div>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/civil/civil-disclaimer/civil-disclaimer.component.html